import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	workItemsFound: {
		id: 'ai-related-issues.find-similar-work-items.items-found',
		defaultMessage: '{itemCount} items found',
		description: 'Message inside Badge saying how many work items found',
	},
	noWorkItemsFound: {
		id: 'ai-related-issues.find-similar-work-items.no-items-found',
		defaultMessage: 'No similar items found',
		description: 'Message inside Badge saying how many no similar work items found',
	},
	similarItems: {
		id: 'ai-related-issues.find-similar-work-items.title',
		defaultMessage: 'Similar items',
		description: 'Similar items title on the collapsible parent',
	},
	beta: {
		id: 'ai-related-issues.find-similar-work-items.beta',
		defaultMessage: 'BETA',
		description: 'Lozenge to indicate that feature is in beta phase',
	},
	findingResults: {
		id: 'ai-related-issues.find-similar-work-items.finding-results',
		defaultMessage: 'Finding results',
		description: 'Text to indicate that the AI is finding results',
	},
	noItemsFound: {
		id: 'ai-related-issues.find-similar-work-items.no-items',
		defaultMessage: 'No items found',
		description: 'Message shown when no items are found',
	},
	somethingWentWrong: {
		id: 'ai-related-issues.find-similar-work-items.error',
		defaultMessage: 'Something went wrong',
		description: 'Error message shown when there is a problem',
	},
	viewItems: {
		id: 'ai-related-issues.find-similar-work-items.view-items',
		defaultMessage: 'View items',
		description: 'Button text to view suggested items',
	},
	hideSuggestions: {
		id: 'ai-related-issues.find-similar-work-items.hide-suggestions',
		defaultMessage: 'Hide Suggestions',
		description: 'Button text to hide suggested items',
	},
	updateDescriptionAndRetry: {
		id: 'ai-related-issues.find-similar-work-items.update-description-and-retry',
		defaultMessage: 'Update description and retry',
		description: 'Error message shown when there is a problem with the Atlassian Intelligence call',
	},
	noSimilarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.no-similar-work-items',
		defaultMessage: 'No similar work items',
		description: 'Message shown when no similar work items are found',
	},
	similarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.similar-work-items',
		defaultMessage: 'Similar work items',
		description: 'Title of the collapsible parent',
	},
});
